import StringConst from "../../StringConst";

export const riskFactorType = (data) => {
    let financialData = [], nonFinancialData = [], overrideData = [], riskData;
    data.forEach(element => {
        if (element.displayNameType === StringConst.SECTION_TYPE_FINANCIAL) {
            let temp = {
                riskFactorName: element.riskFactorName,
                assignedWeight: element.assignedWeight
            };
            financialData.push(temp);
        } else if(element.displayNameType === 'NON_FINANCIAL') {
            let temp = {
                riskFactorName: element.riskFactorName,
                assignedWeight: element.assignedWeight
            };
            nonFinancialData.push(temp)
        } else if(element.displayNameType === 'OVERRIDDEN') {
            let temp = {
                riskFactorName: element.riskFactorName,
                assignedWeight: element.assignedWeight
            };
            overrideData.push(temp);
        } else {
            let temp = {
                riskFactorName: element.riskFactorName,
                assignedWeight: element.assignedWeight
            };
            nonFinancialData.push(temp)
            financialData.push(temp);
            overrideData.push(temp);
        }
    });
    riskData = [{
        financialData: financialData,
        nonFinancialData: nonFinancialData,
        overrideData: overrideData
    }]
    return riskData;
}